import { useSelector } from 'src/store/store';
import PostItem from 'src/modules/shared/resultsList/components/postItem';
import PollItem, { PollItemType } from 'src/modules/community/communityPosts/components/pollItem';
import VisitorLoginPrompt from 'src/modules/shared/resultsList/components/visitorLoginPrompt';
import { CommunityListPost, ElasticSearchPost } from 'src/constants/types';

export function OrderedPosts() {
  const isLoggedIn = useSelector(({ context }) => context.currentUser?.userId);
  const currentCommunity = useSelector(({ context }) => context.currentCommunity);

  const { filter = 'latest', posts = [] } = useSelector(({ pages }) => pages.communityPosts);

  const isPoll = filter === 'polls';
  const postsList = isPoll
    ? posts.map((poll: PollItemType) => <PollItem key={poll.postId} poll={poll} />)
    : posts.map((post: CommunityListPost | ElasticSearchPost) => (
      <PostItem
        community={currentCommunity}
        isSearchPost={false}
        key={post.postId}
        post={post}
      />
    ));
  if (!isLoggedIn) {
    return [...postsList.slice(0, 3), <VisitorLoginPrompt key="visitor-prompt" />, ...postsList.slice(3)];
  } else {
    return postsList;
  }
}
